import { Badge } from '@/components/ui/badge.js';
import { CoachSessionRemarkV2, CoachSessionRemarkV2LabelMap } from '@airreading/common/data';

interface TeacherDisplayTagBadgeV2Props {
  tags: CoachSessionRemarkV2[] | null | undefined;
  testId?: string;
}

export function TeacherDisplayTagBadgeV2({ tags, testId }: TeacherDisplayTagBadgeV2Props) {
  if (!tags || tags.length === 0) {
    return <span data-testid={testId}>—</span>;
  }

  return (
    <div className="flex flex-col gap-1 items-center">
      {tags.map((tag, index) => (
        <Badge
          key={tag}
          variant="outline"
          className="text-center"
          data-testid={testId && (tags.length === 1 ? testId : `${testId}-${index + 1}`)}
        >
          {CoachSessionRemarkV2LabelMap[tag]}
        </Badge>
      ))}
    </div>
  );
}
